import { BasicConfirmationModal } from 'components/ConfirmationModals/BasicConfirmationModal'
import { useAlert } from 'providers'
import { useCallback } from 'react'

type UseConfirmationProps = {
  header: string
  body?: string
  confirmText?: string
  shouldConfirm?: () => boolean
}
export const useConfirmation = ({
  header,
  body,
  confirmText = 'Continue',
  shouldConfirm = () => true,
}: UseConfirmationProps): (() => Promise<boolean>) => {
  const {
    interceptConfirm,
    interceptCancel,
    handleCancel,
    createAlert,
    finalizeConfirm,
    finalizeCancel,
  } = useAlert()

  const createModal = useCallback(
    () =>
      new Promise<boolean>((resolve) => {
        interceptConfirm(() => {
          resolve(true)
          finalizeConfirm()
        })
        interceptCancel(() => {
          resolve(false)
          finalizeCancel()
        })
        createAlert({
          content: (
            <BasicConfirmationModal
              header={header}
              body={body}
              handleCancel={handleCancel}
            />
          ),
          confirmText,
        })
      }),
    [
      confirmText,
      body,
      header,
      interceptConfirm,
      finalizeConfirm,
      createAlert,
      handleCancel,
      interceptCancel,
      finalizeCancel,
    ]
  )
  const askConfirmation = useCallback(async () => {
    //Is confirmation needed?
    if (shouldConfirm()) {
      return await createModal()
    } else {
      return true
    }
  }, [createModal, shouldConfirm])
  return askConfirmation
}
